/**
 * @generated SignedSource<<a68ae5330565bd35c90bb61f3c84ad2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DatabaseType = "ATHENA" | "BIG_QUERY" | "DATABRICKS" | "REDSHIFT" | "SNOWFLAKE" | "TRINO";
export type JobTitleEnum = "Data" | "Engineering" | "Marketing" | "Other" | "Product";
export type UserRoleEnum = "Admin" | "DataOwner" | "ExperimentEditor" | "Viewer";
export type authorizeUserQuery$variables = Record<PropertyKey, never>;
export type authorizeUserQuery$data = {
  readonly userContext: {
    readonly currentCompany: {
      readonly companyId: number;
      readonly config: {
        readonly hideDefinitionSqlRows: boolean;
      };
      readonly createdAt: string;
      readonly databaseConnections: ReadonlyArray<{
        readonly databaseType: DatabaseType;
      }>;
      readonly name: string;
      readonly primaryDomain: {
        readonly domain: string;
      } | null;
    };
    readonly email: string;
    readonly isIntercomEnabled: boolean | null;
    readonly jobTitle: JobTitleEnum | null;
    readonly permissions: ReadonlyArray<string>;
    readonly role: UserRoleEnum;
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly userId: number;
  };
};
export type authorizeUserQuery = {
  response: authorizeUserQuery$data;
  variables: authorizeUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isIntercomEnabled",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "CompanyConfigOutput",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hideDefinitionSqlRows",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domain",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": [
    (v12/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "authorizeUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserContext",
        "kind": "LinkedField",
        "name": "userContext",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "currentCompany",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DatabaseConnection",
                "kind": "LinkedField",
                "name": "databaseConnections",
                "plural": true,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AllowedDomain",
                "kind": "LinkedField",
                "name": "primaryDomain",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "authorizeUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserContext",
        "kind": "LinkedField",
        "name": "userContext",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "currentCompany",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DatabaseConnection",
                "kind": "LinkedField",
                "name": "databaseConnections",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AllowedDomain",
                "kind": "LinkedField",
                "name": "primaryDomain",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f993a3fe159640bb709e297952a8e673",
    "id": null,
    "metadata": {},
    "name": "authorizeUserQuery",
    "operationKind": "query",
    "text": "query authorizeUserQuery {\n  userContext {\n    userId\n    isIntercomEnabled\n    email\n    role\n    jobTitle\n    currentCompany {\n      companyId\n      name\n      databaseConnections {\n        databaseType\n        id\n      }\n      config {\n        hideDefinitionSqlRows\n      }\n      primaryDomain {\n        domain\n        id\n      }\n      createdAt\n      id\n    }\n    permissions\n    teams {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f8a87d7eac880e7f7a745d948fdf92b";

export default node;
